import { useEffect, useMemo, useState } from "react";
import type { TablePageInfo } from "@its-engineering-and-development/ui-foundation/components";

export const POLICY_TABLE_PAGE_SIZE = 10;

export function usePolicyTablePagination<T>(rows: T[], resetKey: string) {
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        setCurrentPage(0);
    }, [resetKey]);

    useEffect(() => {
        const maxPage = Math.max(0, Math.ceil(rows.length / POLICY_TABLE_PAGE_SIZE) - 1);
        if (currentPage > maxPage) {
            setCurrentPage(maxPage);
        }
    }, [rows.length, currentPage]);

    const pageInfo = useMemo((): TablePageInfo | null => {
        if (rows.length === 0) return null;

        const offset = currentPage * POLICY_TABLE_PAGE_SIZE;
        return {
            totalCount: rows.length,
            offset,
            limit: POLICY_TABLE_PAGE_SIZE,
            hasNextPage: offset + POLICY_TABLE_PAGE_SIZE < rows.length,
        };
    }, [rows.length, currentPage]);

    const paginatedRows = useMemo(() => {
        const offset = currentPage * POLICY_TABLE_PAGE_SIZE;
        return rows.slice(offset, offset + POLICY_TABLE_PAGE_SIZE);
    }, [rows, currentPage]);

    return { paginatedRows, pageInfo, setPage: setCurrentPage };
}
